import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Input, Button, InputRef } from 'antd';
import { StyledSearch } from './styled';
import { SearchOutlined } from '@ant-design/icons';
import { debounce } from 'lodash';

function Search({ onSearch, text, collapsedCallback = (value) => {} }) {
  const inputRef = useRef<InputRef>(null);
  const [collapsed, setCollapsed] = useState(true);

  const expand = () => {
    setCollapsed(false);
    collapsedCallback(false);
    // next render mounts the input
    setTimeout(() => {
      inputRef.current!.focus({
        cursor: 'start',
      });
    });
  };

  const handleSearch = useCallback(
    (value) => {
      onSearch(value.toLowerCase());
    },
    [onSearch],
  );

  // search on change
  const debouncedSearch = useMemo(() => debounce(handleSearch, 200), [handleSearch]);
  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      debouncedSearch(value);
    },
    [debouncedSearch],
  );

  const handleBlur = () => {
    if (text === '') {
      setCollapsed(true);
      collapsedCallback(true);
    }
  };

  return (
    <StyledSearch>
      {collapsed ? (
        <Button size="small" icon={<SearchOutlined />} onClick={expand} />
      ) : (
        <Input.Search
          ref={inputRef}
          placeholder="Search"
          allowClear
          onSearch={handleSearch}
          onChange={handleChange}
          style={{ width: 200 }}
          onBlur={handleBlur}
        />
      )}
    </StyledSearch>
  );
}

export default Search;
